import React, { Component } from "react";
import firebase from "../../utils/firebase";
import moment from "moment";
import { Link } from "react-router-dom";

import MyTable from "../../components/myTable/MyTable";

import Button from "@atlaskit/button";

import { FieldTextStateless } from "@atlaskit/field-text";
import Tabs from "@atlaskit/tabs/dist/cjs/components/Tabs";

import "./admin.css";
export default class AdminUsers extends Component {
  constructor() {
    super();

    this.state = {
      users: [],
      phoneNumber: "",
      email: "",
      uid: ""
    };
  }

  getUsers = async param => {
    this.setState({ loading: true });
    try {
      const query = this.state[param];
      const users = await firebase
        .firestore()
        .collection("my")
        .where(param, "==", query)
        .get()
        .then(querySnapshot => querySnapshot.docs)
        .then(docs => docs.map(doc => doc.data()));
      this.setState({
        users,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  fieldHandler = e => this.setState({ [`${e.target.name}`]: e.target.value });

  tabHandler = (tab, i) => this.setState({ tab: i });

  render() {
    console.log(this.state);
    return (
      <div className="admin-users">
        <Tabs
          onSelect={this.tabHandler}
          selected={this.state.tab}
          tabs={[
            {
              label: "User ID",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__uid-input"
                    onChange={this.fieldHandler}
                    name="uid"
                    value={this.state.uid}
                    aria-label="User ID"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="User ID..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.uid}
                    onClick={e => this.getUsers("uid")}
                  >
                    Search
                  </Button>
                </div>
              )
            },
            {
              label: "Email",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__email-input"
                    onChange={this.fieldHandler}
                    name="email"
                    value={this.state.email}
                    aria-label="User Email"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="Email..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.email}
                    onClick={e => this.getUsers("email")}
                  >
                    Search
                  </Button>
                </div>
              )
            },
            {
              label: "Phone",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__phone-input"
                    onChange={this.fieldHandler}
                    name="phoneNumber"
                    value={this.state.phoneNumber}
                    aria-label="Phone Number"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="Phone Number..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.phoneNumber}
                    onClick={e => this.getUsers("phoneNumber")}
                  >
                    Search
                  </Button>
                </div>
              )
            }
          ]}
        />
        <div className="admin-results">
          <MyTable
            caption="Users"
            head={{
              cells: [
                {
                  key: "uid",
                  content: (
                    <span className="users-admin__table-header-cell">
                      UserID
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "email",
                  content: (
                    <span className="users-admin__table-header-cell">
                      Email
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "date",
                  content: (
                    <span className="users-admin__table-header-cell">
                      Created
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                }
              ]
            }}
            rows={this.state.users.map((user, i) => {
              console.log(user);
              return {
                key: `user-admin__row_${i}`,
                cells: [
                  {
                    key: `uid`,
                    content: (
                      <Link to={`/admin/user?uid=${user.uid}`}>
                        <span>{user.uid}</span>
                      </Link>
                    )
                  },
                  {
                    key: `email`,
                    content: <span>{user.email}</span>
                  },
                  {
                    key: `date`,
                    content: (
                      <span>
                        {moment(user.created.toDate()).format("MMM Do")}
                      </span>
                    )
                  }
                ]
              };
            })}
            emptyView={<span>No Users</span>}
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin/AdminUsers.js